import { createSlice } from '@reduxjs/toolkit';
import { IMagicRemoteState } from '../../types/interfaces/states';
import { RootState } from '../store';

const initialState: IMagicRemoteState = {
  enabled: false,
  hoveringElement: false,
};

const magicRemoteSlice = createSlice({
  name: 'magicRemote',
  initialState,
  reducers: {
    enable: (state) => {
      state.enabled = true;
    },
    disable: (state) => {
      state.enabled = false;
    },
    hoverElement: (state) => {
      if (state.enabled) {
        state.hoveringElement = true;
      }
    },
    leaveElement: (state) => {
      state.hoveringElement = false;
    },
  },
});

const { actions, reducer: magicRemoteReducer } = magicRemoteSlice;
export const { enable, disable, hoverElement, leaveElement } = actions;
export const magicRemoteSelector = (state: RootState) => state.magicRemote;
export default magicRemoteReducer;
